import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { getMyGemService } from "@/services";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";

export default class CheckLayoutService extends ApiService {
  namespace = "check/layouts";
  template = "defaultTemplate";
  fullWindow = false;
  showLeftBar = false;
  icon = "SafetyBox";
  DOMAIN = DOMAIN.CHECK_LAYOUT;
  data = [];
  favicon = "database";
  name = "Deposits";
  singular = this.terminology.checkLayout.singular;
  plural = this.terminology.checkLayout.plural;
  vowel = this.terminology.checkLayout.vowel;
  layout = 2;
  Width = 1500;
  layoutItems = [
    {
      name: "COMPANY_NAME_ADDRESS",
      label: "Company Name and Address",
      value: "Company Name<br> Company Address<br>St, 10009",
      x: "11.600006103515625px",
      y: "17.8px",
      font: "Century Gothic",
      size: "0.134",
      color: "000000",
    },
    {
      name: "CHECK_NUMBER",
      label: "Check Number",
      value: "XXXXXX",
      x: "719px",
      y: "23.04px",
      font: "Courier New",
      size: "0.135",
      color: "000000",
    },
    {
      name: "BILLING_DATE",
      label: "Billing Date",
      value: "mm/dd/yyyy",
      x: "719px",
      y: "46.08px",
      font: "Century Gothic",
      size: "0.135",
      color: "000000",
      class: "check-date",
    },
    {
      name: "PAYEE_ACCOUNT",
      label: "Payee Account",
      value: "Payee Account",
      x: "75.91668701171875px",
      y: "108.8px",
      font: "Century Gothic",
      size: "0.135",
      color: "000000",
      class: "payee-account",
    },
    {
      name: "AMOUNT_CURRENCY",
      label: "Amount in Dollars",
      value: "10,000.00",
      x: "729.6px",
      y: "108.8px",
      font: "Century Gothic",
      size: "0.135",
      color: "000000",
      class: "check-amt-num",
    },
    {
      name: "AMOUNT_WORDS",
      label: "Amount in Words",
      value: "Ten Thounsand  .0/100 Dollars",
      x: "11.600006103515625px",
      y: "141.283px",
      font: "Century Gothic",
      size: "0.135",
      color: "000000",
      class: "check-amt-words",
    },
    {
      name: "PAYEE_NAME_ADDRESS",
      label: "Payee Name and Address",
      value: "Payee Name <br> Payee Address<br>St, 10009",
      x: "11.600006103515625px",
      y: "196px",
      font: "Century Gothic",
      size: "0.135",
      color: "000000",
    },
    {
      name: "MEMO",
      label: "Memo",
      value: "Just a memo",
      x: "67.2px",
      y: "282.24px",
      font: "Century Gothic",
      size: "0.135",
      color: "000000",
      class: "memo-line",
    },
    {
      name: "LOGO",
      label: "Logo",
      value: require("@/assets/images/logo-1.png"),
      x: "163.633px",
      y: "6.13333px",
      width: "80",
      height: "80",
      type: "img",
    },
    {
      name: "SIGNATURE",
      label: "Signature",
      value: "",
      x: "727.8px",
      y: "237.4px",
      width: "48",
      height: "48",
      type: "img",
    },
  ];
  printingOptions = [
    {
      name: "is_print_logo",
      label: this.t("Print Logo"),
    },
    {
      name: "is_print_signature",
      label: this.t("Print Signature"),
    },
    {
      name: "is_print_company_address",
      label: this.t("Print Company Name & Address"),
    },

    {
      name: "is_print_payee_address",
      label: this.t("Print Payee Name & Address"),
    },
    {
      name: "is_print_check_number",
      label: this.t("Print Check Number"),
    },
    {
      name: "line_item_company",
      label: this.t("Display Company Name under List Items"),
    },
  ];
  gemItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: PrimeIcons.LIST,
    },
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: PrimeIcons.PLUS,
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "id",
    },
    {
      header: this.t("displayName"),
      icon: AppIcons.TAG,
      field: "display_name",
    },
    {
      header: this.t("useSignature"),
      icon: AppIcons.TICK,
      field: "is_print_signature",
      template: (data) => {
        return data.is_print_signature == 1 ? "Yes" : "No";
      },
    },
    {
      header: this.t("printCheckNum"),
      icon: AppIcons.PRINTER,
      field: "is_print_check_number",
      template: (data) => {
        return data.is_print_check_number == 1 ? "Yes" : "No";
      },
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "updated_at",
      template: (data) => {
        return moment(String(data.updated_at)).format("MM/DD/YYYY");
      },
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "create",
      label: "Load template",
      icon: AppIcons.FOLDER,
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      icon: AppIcons.PREVIEW,
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      icon: AppIcons.PRINTER,
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      icon: AppIcons.MAIL,
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      icon: AppIcons.LAYOUT,
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit this Invoice...",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.BULLETS,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Record a Deposit",
      icon: PrimeIcons.LIST,
    },
  ];

  constructor() {
    super("check-layouts");
  }

  getName(serviceId, id) {
    var service = getMyGemService(serviceId);
    return service.retrieve(id).then((d) => {
      return d;
    });
  }
}
